// extracted by mini-css-extract-plugin
module.exports = {"plOrdReleaseTable":"styles_plOrdReleaseTable__1OU2U"};